export default "__VITE_ASSET__CCcuPyfa__"